/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ArticlesInputs */

const cs_nav_articles = /** @type {(inputs: Nav_ArticlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Články`)
};

const sk_nav_articles = /** @type {(inputs: Nav_ArticlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Články`)
};

const en_nav_articles = /** @type {(inputs: Nav_ArticlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles`)
};

/**
* | output |
* | --- |
* | "Articles" |
*
* @param {Nav_ArticlesInputs} inputs
* @param {{ locale?: "cs" | "sk" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_articles = /** @type {((inputs?: Nav_ArticlesInputs, options?: { locale?: "cs" | "sk" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ArticlesInputs, { locale?: "cs" | "sk" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "cs") return cs_nav_articles(inputs)
	if (locale === "sk") return sk_nav_articles(inputs)
	return en_nav_articles(inputs)
});